export default __webpack_public_path__ + "static/media/Butch Blue Label Dog and Cat Foo.d2d0e645.png";